module.exports = __webpack_public_path__ + "static/media/login_bg.a91e30fc.svg";